const system = {
  namespaced: true,
  state: {
      settingsList: null,
      categoriesList: null
  },
  mutations: {
    setSettingsList(state, newList) {
      state.settingsList = newList;
    },
    setCategoriesList(state, newList) {
      state.categoriesList = newList
    }
  },
  getters: {
    getSetting: state => name => {
      const setting = state.settingsList?.find(s => s.name === name);
      return setting?.value || '';
    }
  },
  actions: {
    getSettingsList(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http.get('/traveller/restui/settings/getSettingsList')
          .then(response => {
              context.commit('setSettingsList', response.data);
              resolve(response.data);
              return;
          }),
          error => {
            reject(error);
          }
      });

      
    },
    getCategoriesList(context){
      return new Promise((resolve, reject) => {
      this._vm.$traveller_http.get('/traveller/restui/settings/getCategoriesList')
      .then(response => {
          context.commit('setCategoriesList', response.data);
          resolve(response.data);
          return;
      }),
      error => {
        reject(error);
      }
      })
    },
    changeSetting(context, params) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http.post('/traveller/restui/settings/changeSetting', null, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          params: {id: params.id, value: params.value}
        })
          .then(response => {
              context.dispatch('getSettingsList');
              resolve(response);
          }),
          error => {
            reject(error);
          }
      });
    },
  }
}

export default system;